import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import track from 'utils/track';
import api from 'utils/api';
import { assetQueryKeys } from '.';
import { playlistQueryKeys } from 'actions/playlists';
export function useUnmarkMyAssetAsDone(options) {
  var queryClient = useQueryClient();
  function unmarkAssetAsDone(_x) {
    return _unmarkAssetAsDone.apply(this, arguments);
  }
  function _unmarkAssetAsDone() {
    _unmarkAssetAsDone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, playlistId;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, playlistId = _ref.playlistId;
            return _context.abrupt("return", api('put', "/api/me/assets/".concat(id, "/unread"), {
              collection_id: playlistId
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _unmarkAssetAsDone.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: unmarkAssetAsDone
    }, options), {}, {
      onSuccess: function onSuccess(data, variables) {
        track('asset', 'unread', variables === null || variables === void 0 ? void 0 : variables.id);
        return Promise.all([queryClient.invalidateQueries({
          queryKey: assetQueryKeys.singleAsset(variables === null || variables === void 0 ? void 0 : variables.id)
        }), queryClient.invalidateQueries({
          queryKey: playlistQueryKeys.allPlaylists
        })]);
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    unmarkMyAssetAsDone: mutateAsync
  });
}
export default useUnmarkMyAssetAsDone;